<template>
  <div>
    <div class="text-base ml-5 opacity-[0.9]">{{ menu.meta?.title }}</div>
    <div class="grid justify-center grid-cols-[repeat(3,1fr)] gap-y-2.5 gap-x-5 p-2.5 w-[760px]">
      <div class="items-center rounded hover:cursor-pointer hover:bg-active" v-for="item in menu.children" :key="item.path">
        <LinkItem
          :to="item.path"
          class="w-full inline-block box-border py-2.5 rounded"
          :class="[isPathPrefix(item.path) ? 'bg-active' : '']"
        >
          <div class="flex flex-row">
            <div class="w-12 grid text-3xl place-items-center">
              <SvgIcon v-if="item.meta?.svgIcon" :name="item.meta?.svgIcon" />
            </div>
            <div class="flex flex-col">
              <div class="flex flex-row items-center">
                <span class="text-sm py-1 px-1.5 w-19">{{ item.meta?.title }}</span>
                <span
                  class="bg-[#E8F6FB] rounded-sm text-xs py-0.5 px-2.5 text-primary opacity-75"
                  :class="[item.meta?.tag == 'dev' ? 'bg-[#FFF2CC] text-[#FF8C00]!' : '']"
                  >{{ item.meta?.tag }}</span
                >
              </div>
              <div class="text-xs opacity-50 pl-1.5">{{ item.meta?.description }}</div>
            </div>
          </div>
        </LinkItem>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { RouteRecordRaw } from '~/types/router';

interface Props {
  menu: RouteRecordRaw;
}

defineProps<Props>();

const route = useRoute();
const activeMenu = computed(() => {
  const {
    meta: { activeMenu },
    path,
  } = route;
  return activeMenu ? activeMenu : path;
});

const isPathPrefix = (path2: string) => {
  const path1 = activeMenu.value as string;
  return path1 === path2;
};
</script>
